/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { gql } from '@apollo/client';

export const EntitlementTemplateFragment = {
  entitlementTemplateFields: gql`
    fragment EntitlementTemplateFields on EntitlementTemplate {
      _id
      name
      type
      description
      vamProducts
      geography {
        name
        isoCode
      }
      # reports {
      #   _id
      #   title
      #   subTitle
      #   description
      #   s3File {
      #     key
      #     bucket
      #     originalUrl
      #   }
      #   thumbnail {
      #     key
      #     bucket
      #     originalUrl
      #   }
      #   status
      #   type
      # }
      tags {
        filterKey
        allowedValues
        excludedValues
      }
      relevanceTags {
        filterKey
        allowedValues
        excludedValues
      }
      paths {
        allowedValues
        excludedValues
      }
      marketplaceFeatures
      status
    }
  `,
};

export const EmEntitlementFragment = {
  emEntitlementFields: gql`
    fragment EmEntitlementFields on EmEntitlement {
      _id
      name
      type
      description
      vamProducts
      geography {
        name
        isoCode
      }
      elasticDsl
      reports {
        _id
        title
        subTitle
        description
        s3File {
          key
          bucket
          originalUrl
        }
        thumbnail {
          key
          bucket
          originalUrl
        }
        status
        type
      }
      relevanceTags {
        filterKey
        allowedValues
        excludedValues
      }
      tags {
        filterKey
        allowedValues
        excludedValues
      }
      paths {
        allowedValues
        excludedValues
      }
      marketplaceFeatures
      status
    }
  `,
};
